import React, { Component } from "react";
import 'react-circular-progressbar/dist/styles.css';

import MessagePanel from './../../components/panels/message'

//import Progress from 'react-progressbar';

class MessagePage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      message: null,
      body: null
    };
  }

  render() {
    return <MessagePanel tenantId={this.props.match.params.tenantId} messageId={this.props.match.params.messageId} />;
  }

}




export default MessagePage
